import React, { useEffect, useState } from 'react';
import {
  FormControl, InputLabel, Select, MenuItem, Button, TextField, Grid, Typography, Link, Box, FormControlLabel, Checkbox, makeStyles, ButtonBase
} from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';

import { useSelector } from 'react-redux';
import moment from 'moment';
import { useTranslation } from '../LocalizationProvider';
import { console_log, convertUnixTimestampToTimezone, empty, getLocalTimezone, getUnixTimestampFromTimezone, getUtcFromTimezone, is_null, getFormattedTime, get_utc_timestamp_ms, randomString } from '../helpers/untils';
import { Stack } from '@mui/material';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import LinkGeofenceModal, { defaultGeofenceSettings, mergeGeofenceSettings, unionGeofenceIds } from './LinkGeofenceModal';
import TimezoneAutoCompleteDropdown from '../components/TimezoneAutoCompleteDropdown';
import ShareReservationSettingForm from './ShareReservationSettingForm';
import { DEVICE_TYPE, RESERVATION_ACCESS_STATUS, SHARE_ACCESS_LOGIN_TYPE, SHARE_RESERVATION_VIDEO_ID } from '../config/constant';

import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss';

const useStyles = makeStyles((theme) => ({
  formRowInlineController: {
    flex: 1
  },
  toggle: {
    color: '#333',
    border: '1px solid #ccc',
    '&.Mui-selected': {
      color: '#fff',
      backgroundColor: '#333366',
      borderColor: '#333366',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'rgb(35, 35, 71)',
    },
  },
}));

const LOCAL_TIMEZONE = getLocalTimezone()

const ShareReservationFilter = (props) => {
  const { children, handleSubmit, showOnly, selectedDeviceId, setSelectedDeviceId, selectedDevice, tripList, trip, setTrip, snackbarOpen, setSnackbarOpen, toastMessage, setToastMessage, history, shareUrl, apiLoading, setApiLoading, pageData, setPageData, generatedUrl, showToast, copyTextClipboard, onClickSMS, onClickVoice, usedTripIds = [] } = props

  const t = useTranslation();
  const classes = useStyles();
  const user = useSelector((state) => state.session.user);

  const devices = useSelector((state) => Object.values(state.devices.items));
  const [deviceId, setDeviceId] = useState(selectedDeviceId);

  const defaultFormData = {
    share_minutes_before: 60,
    share_minutes_after: 30,
    allot_miles: '',
    auto_lock: false,
    auto_send_toll: false,
    auto_send_toll_email: user?.email,
    daily_send_toll: false,
    auto_send_charging: false,
    auto_send_charging_email: user?.email,
    daily_send_charging: false,
    auto_unkill_on_unlock: true,
    enable_tesla_phone_key: true,
    accessStatus: RESERVATION_ACCESS_STATUS.OFF,
    login_with: "",
    host_code: "",
  }
  const [formData, setFormData] = useState(defaultFormData)
  const [geofenceSettings, setGeofenceSettings] = useState(defaultGeofenceSettings())

  useEffect(() => {
    initDefaultSettings()
  }, [selectedDevice])

  const initDefaultSettings = () => {
    //console.log("selectedDevice::::", selectedDevice)
    if (selectedDevice) {
      let shareSettings = selectedDevice?.share_settings // tripShareSetting
      if (!empty(shareSettings)) {
        let shareSettingsObj = JSON.parse(shareSettings)
        if (shareSettingsObj['tripShareSetting']) {
          shareSettings = shareSettingsObj['tripShareSetting']
        } else {
          shareSettings = shareSettingsObj
        }
      } else {
        shareSettings = {}
      }

      shareSettings['auto_lock'] = (shareSettings['auto_lock'] === "true")
      shareSettings['auto_send_toll'] = (shareSettings['auto_send_toll'] === "true")
      shareSettings['daily_send_toll'] = (shareSettings['daily_send_toll'] === "true")
      shareSettings['auto_send_charging'] = (shareSettings['auto_send_charging'] === "true")
      shareSettings['daily_send_charging'] = (shareSettings['daily_send_charging'] === "true")
      shareSettings['auto_unkill_on_unlock'] = (shareSettings['auto_unkill_on_unlock'] === "true")
      if (!is_null(shareSettings['enable_tesla_phone_key'])) {
        shareSettings['enable_tesla_phone_key'] = (shareSettings['enable_tesla_phone_key'] === "true")
      }
      if (shareSettings['accessStatus']) {
        shareSettings['accessStatus'] = Number(shareSettings['accessStatus'])
      }
      if (!shareSettings['login_with']) {
        shareSettings['login_with'] = SHARE_ACCESS_LOGIN_TYPE.HOST_CODE
      }
      if (!shareSettings['host_code']) {
        if (!user.phone) {
          shareSettings['host_code'] = randomString(7, true)
        } else {
          shareSettings['host_code'] = user.phone
        }
      }

      const _form_data = {
        ...defaultFormData,
        ...shareSettings
      }
      console.log(`_form_data:::`, _form_data)
      setFormData(_form_data)

      if (!empty(shareSettings['geofenceSettings'])) {
        setGeofenceSettings(mergeGeofenceSettings(shareSettings['geofenceSettings']))
      } else if (!empty(shareSettings['selectedGeofenceIds']) && shareSettings['selectedGeofenceIds'].length > 0) {
        // Migrate legacy flat geofence ids into the Return section.
        const migrated = defaultGeofenceSettings()
        migrated.return.geofenceIds = shareSettings['selectedGeofenceIds']
        setGeofenceSettings(migrated)
      }
    }
  }

  ///////////////////////////////////////////////////////
  const [timezone, setTimezone] = useState(LOCAL_TIMEZONE);

  const handleClick = async (form_data, scrollDown = true) => {
    const iana_timezone = timezone
    form_data.append("deviceId", deviceId);
    form_data.append("timezone", iana_timezone);
    form_data.append("share_minutes_before", formData['share_minutes_before']);
    form_data.append("share_minutes_after", formData['share_minutes_after']);
    //form_data.append("allot_miles", formData['allot_miles']);
    form_data.append("auto_lock", formData['auto_lock']);
    form_data.append("auto_send_toll", formData['auto_send_toll']);
    form_data.append("auto_send_toll_email", formData['auto_send_toll_email']);
    form_data.append("daily_send_toll", formData['daily_send_toll']);
    form_data.append("auto_send_charging", formData['auto_send_charging']);
    form_data.append("auto_send_charging_email", formData['auto_send_charging_email']);
    form_data.append("daily_send_charging", formData['daily_send_charging']);
    form_data.append("auto_unkill_on_unlock", formData['auto_unkill_on_unlock'] ? "true" : "false");
    form_data.append("enable_tesla_phone_key", formData['enable_tesla_phone_key']);
    form_data.append("accessStatus", formData['accessStatus']);
    form_data.append("login_with", formData['login_with']);
    form_data.append("host_code", formData['host_code']);
    form_data.append("selectedGeofenceIds", JSON.stringify(geofenceSettings.return.geofenceIds ?? [])); //unionGeofenceIds(geofenceSettings)
    form_data.append("geofenceSettings", JSON.stringify(geofenceSettings));

    if (formData['login_with'] === SHARE_ACCESS_LOGIN_TYPE.HOST_CODE) {
      if (!formData['host_code'] || formData['host_code'].length <= 4) {
        alert("Host Code must be at least 5 characters long");
        return false
      }
    }

    handleSubmit(form_data, scrollDown)
  }

  const onChangeCheckBox = (event, field_name) => {
    let form_data = { ...formData }
    form_data[field_name] = event.target.checked
    setFormData(form_data)
  }

  const onChangeFormInput = (event, field_name) => {
    let form_data = { ...formData }
    form_data[field_name] = event.target.value
    setFormData(form_data)
    if (field_name === 'login_with') {
      setAccessStatusTimestamp(get_utc_timestamp_ms())
    }
  }

  const handleBlurHostCode = (event) => {
    const value = event.target.value
    console_log(`handleBlurHostCode:::`, event, value)
    if (value && value.length > 4) {
      let form_data = { ...formData }
      form_data['host_code'] = value
      setFormData(form_data)
      setAccessStatusTimestamp(get_utc_timestamp_ms())
    } else {
      alert("Host Code must be at least 5 characters long");
    }
  }

  const onChangeAllot = (e) => {
    let allot_miles = e.target.value
    const form_data = { ...formData }
    form_data['allot_miles'] = allot_miles
    setFormData(form_data)
  }

  const [showLinkGeofenceModal, setShowLinkGeofenceModal] = useState(false)
  const onClickMapIcon = () => {
    setShowLinkGeofenceModal(true)
  }

  const [accessStatusTimestamp, setAccessStatusTimestamp] = useState(0)
  const handleAccessStatusChange = (event, newVal) => {
    if (newVal !== null) {
      setFormData({
        ...formData,
        accessStatus: newVal
      })
      setAccessStatusTimestamp(get_utc_timestamp_ms())
    }
  }

  const [videoOpen, setVideoOpen] = useState(false)

  const onClickVideoLink = () => {
    console.log(`onClickVideoLink:::`)
    setVideoOpen(true)
  }

  return (
    <>
      <Grid container spacing={1} justifyContent="flex-start">
        <Grid item xs={12} sm={12}>
          <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={2}>
            <ToggleButtonGroup
              value={formData['accessStatus']}
              exclusive
              onChange={handleAccessStatusChange}
              aria-label="toggle switch"
              size="small"
              color="secondary"
            >
              <ToggleButton value={RESERVATION_ACCESS_STATUS.OFF} className={classes.toggle} style={{ width: '60px' }} aria-label="Off">
                Off
              </ToggleButton>
              <ToggleButton value={RESERVATION_ACCESS_STATUS.ON} className={classes.toggle} style={{ width: '60px' }} aria-label="On">
                On
              </ToggleButton>
              {/* <ToggleButton value={RESERVATION_ACCESS_STATUS.ONE_TIME} className={classes.toggle} style={{ width: '90px' }} aria-label="One Time">
                One Time
              </ToggleButton> */}
            </ToggleButtonGroup>
            <>
              {/* <ButtonBase disableRipple={true}>Video</ButtonBase> */}
              <Typography variant='p' onClick={() => onClickVideoLink()} style={{ cursor: 'pointer', textDecoration: 'underline', color: '#1366ff' }}>Video</Typography>
            </>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Box>
            <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
              <Typography>
                Login with:
              </Typography>
              <Box>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="login-with-controlled-radio-buttons-group"
                    value={formData.login_with || ''}
                    onChange={(event) => onChangeFormInput(event, 'login_with')}
                    style={{ justifyContent: "flex-start" }}
                    row
                  >
                    <FormControlLabel value={SHARE_ACCESS_LOGIN_TYPE.GUEST_PHONE} control={<Radio />} label="Reservation and Guest phone" />
                    <Stack direction={`row`} alignItems={`center`} spacing={0}>
                      <FormControlLabel value={SHARE_ACCESS_LOGIN_TYPE.HOST_CODE} control={<Radio />} label="Reservation and " />
                      <TextField
                        value={formData['host_code']}
                        onChange={(event) => onChangeFormInput(event, 'host_code')}
                        onBlur={handleBlurHostCode}
                        label=""
                        variant="filled"
                        placeholder="Host Code"
                        type="tel"
                        style={{ width: '120px' }}
                      />
                    </Stack>
                  </RadioGroup>
                </FormControl>
              </Box>
            </Stack>
          </Box>
        </Grid>

        <Grid item container xs={12} sm={12} spacing={1}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Minutes Before"
              value={formData['share_minutes_before']}
              onChange={(e) => setFormData({ ...formData, share_minutes_before: e.target.value })}
              variant="filled"
              inputProps={{ type: 'number', min: 0, placeholder: " " }}
              placeholder=" "
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Minutes After"
              value={formData['share_minutes_after']}
              onChange={(e) => setFormData({ ...formData, share_minutes_after: e.target.value })}
              variant="filled"
              inputProps={{ type: 'number', min: 0, placeholder: " " }}
              placeholder=" "
              fullWidth
            />
          </Grid>
        </Grid>
        {/* <Grid item xs={12} sm={12}>
          <Box sx={{ paddingTop: '8px', paddingBottom: '8px', marginBottom: '10px' }}>
            <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1.5}>
              <Typography variant='p'>Allot</Typography>
              <TextField
                variant="filled"
                label=""
                type="text"
                value={formData['allot_miles']}
                onChange={(e) => onChangeAllot(e)}
                style={{ width: '100px' }}
                inputProps={{ type: 'number', min: 0, placeholder: "" }}
              />
              <Typography variant='p'>Miles</Typography>
              <Tooltip
                arrow
                title="How many miles is included in this trip"
              >
                <InfoIcon color="action" />
              </Tooltip>
            </Stack>
          </Box>
        </Grid> */}

        <Grid item xs={12} sm={12}>
          <Stack direction={`row`} sx={{ justifyContent: 'space-between', alignItems: 'center' }} spacing={2}>
            <Stack direction={`row`} sx={{ justifyContent: 'flex-start', alignItems: 'center' }}>
              <FormControlLabel
                control={<Checkbox checked={formData['auto_lock'] ? true : false} onChange={(event) => onChangeCheckBox(event, 'auto_lock')} />}
                label="Auto Lock"
              />
              <Tooltip
                arrow
                title="Lock will be sent at end of trip"
              >
                <InfoIcon color="action" />
              </Tooltip>
            </Stack>
            <Typography variant='p' onClick={() => onClickMapIcon()} style={{ cursor: 'pointer', textDecoration: 'underline', color: '#1366ff' }}>Locations</Typography>
          </Stack>
        </Grid>

        {
          (selectedDevice) && (
            <>
              <Grid item xs={12} sm={12}>
                <ShareReservationSettingForm
                  snackbarOpen={snackbarOpen}
                  setSnackbarOpen={setSnackbarOpen}
                  toastMessage={toastMessage}
                  setToastMessage={setToastMessage}
                  history={history}
                  selectedDeviceId={selectedDeviceId}
                  selectedDevice={selectedDevice}
                  shareUrl={shareUrl}
                  onClickSaveSetting={(form_data, scrollDown) => handleClick(form_data, scrollDown)}
                  apiLoading={apiLoading}
                  setApiLoading={setApiLoading}
                  generatedUrl={generatedUrl}
                  showToast={showToast}
                  copyTextClipboard={copyTextClipboard}
                  accessStatusTimestamp={accessStatusTimestamp}
                >
                  <Grid item xs={12} sm={12}>
                    <Stack direction={`row`} sx={{ justifyContent: 'flex-start', alignItems: 'center' }}>
                      <FormControlLabel
                        control={<Checkbox checked={formData['auto_send_toll'] ? true : false} onChange={(event) => onChangeCheckBox(event, 'auto_send_toll')} />}
                        label="Auto Send Toll"
                      />
                      <TextField
                        fullWidth
                        className={classes.formRowInlineController}
                        value={formData['auto_send_toll_email']}
                        onChange={(event) => onChangeFormInput(event, 'auto_send_toll_email')}
                        label=""
                        placeholder={`Enter emails with comma separated`}
                        variant="filled"
                        inputProps={{ type: 'email' }}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Stack direction={`row`} sx={{ justifyContent: 'flex-end', alignItems: 'center', pr: 1, mt: -1 }}>
                      <FormControlLabel
                        control={<Checkbox checked={formData['daily_send_toll'] ? true : false} onChange={(event) => onChangeCheckBox(event, 'daily_send_toll')} />}
                        label="Send Toll Report Daily"
                        labelPlacement="start"
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Stack direction={`row`} sx={{ justifyContent: 'flex-start', alignItems: 'center' }}>
                      <FormControlLabel
                        control={<Checkbox checked={formData['auto_unkill_on_unlock'] ? true : false} onChange={(event) => onChangeCheckBox(event, 'auto_unkill_on_unlock')} />}
                        label="Auto Unkill the first time renter clicks Unlock"
                      />
                    </Stack>
                  </Grid>
                  {
                    (selectedDevice.deviceType === DEVICE_TYPE.TESLA) ? (
                      <>
                        <Grid item xs={12} sm={12}>
                          <Stack direction={`row`} sx={{ justifyContent: 'flex-start', alignItems: 'center', mb: 1 }}>
                            <FormControlLabel
                              control={<Checkbox checked={formData['enable_tesla_phone_key'] ? true : false} onChange={(event) => onChangeCheckBox(event, 'enable_tesla_phone_key')} />}
                              label={`Enable Tesla Phone Key`}
                            />
                          </Stack>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <Stack direction={`row`} sx={{ justifyContent: 'flex-start', alignItems: 'center' }}>
                            <FormControlLabel
                              control={<Checkbox checked={formData['auto_send_charging'] ? true : false} onChange={(event) => onChangeCheckBox(event, 'auto_send_charging')} />}
                              label="Auto Send Charging"
                            />
                            <TextField
                              fullWidth
                              className={classes.formRowInlineController}
                              value={formData['auto_send_charging_email']}
                              onChange={(event) => onChangeFormInput(event, 'auto_send_charging_email')}
                              label=""
                              placeholder={`Enter emails with comma separated`}
                              variant="filled"
                              inputProps={{ type: 'email' }}
                            />
                          </Stack>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <Stack direction={`row`} sx={{ justifyContent: 'flex-end', alignItems: 'center', pr: 1, mt: -1 }}>
                            <FormControlLabel
                              control={<Checkbox checked={formData['daily_send_charging'] ? true : false} onChange={(event) => onChangeCheckBox(event, 'daily_send_charging')} />}
                              label="Send Charging Daily"
                              labelPlacement="start"
                            />
                          </Stack>
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )
                  }
                </ShareReservationSettingForm>
              </Grid>
            </>
          )
        }
      </Grid>

      <>
        <LinkGeofenceModal
          showToast={(msg) => showToast(msg)}
          selectedDeviceId={selectedDeviceId}
          selectedDevice={selectedDevice}
          open={showLinkGeofenceModal}
          setOpen={setShowLinkGeofenceModal}
          pageData={pageData}
          setPageData={setPageData}
          geofenceSettings={geofenceSettings}
          setGeofenceSettings={setGeofenceSettings}
        />
      </>

      <>
        {
          (videoOpen && SHARE_RESERVATION_VIDEO_ID !== "") ? (
            <>
              <ModalVideo
                channel='youtube'
                autoplay={1}
                youtube={{
                  autoplay: 1,
                  mute: 1
                }}
                isOpen={videoOpen}
                videoId={SHARE_RESERVATION_VIDEO_ID}
                onClose={() => setVideoOpen(false)}
              />
            </>
          ) : (<></>)
        }
      </>

    </>
  )
}

export default ShareReservationFilter;
